// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mp-copy-to-clipboard{display:flex;flex-direction:row}.copy-input{margin-right:5px}.copy-button{align-self:flex-end;display:flex;position:relative}.full-width{width:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
